import _objectSpread from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import yodaBridge from '@ks/yoda-js-sdk';
import { isYodaEnv } from './env';
function proxyBridge(bridge) {
  return new Proxy(bridge, {
    get: function get() {
      return proxyBridge(function () {});
    },
    apply: function apply() {
      return Promise.resolve({});
    }
  });
}
var yoda = isYodaEnv ? yodaBridge : proxyBridge({});
_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return yoda.ready();
        case 2:
          yoda.register({
            namespace: 'component',
            name: 'liveStickerCompoundAndUpload'
          }); // 贴片合成&上传
          yoda.register({
            namespace: 'component',
            name: 'liveDownloadFile'
          }); // 下载精彩瞬间视频
          yoda.register({
            namespace: 'component',
            name: 'liveJumpToEdit'
          }); // 跳转编辑页
          yoda.register({
            namespace: 'component',
            name: 'saveMediaToAlbum'
          }); // 保存到相册
          yoda.register({
            namespace: 'component',
            name: 'liveCancelDownloadTask'
          }); // 取消保存到相册
          yoda.register({
            namespace: 'component',
            name: 'openLiveProfile'
          }); // 客户端判断 半屏调mini profile页 全屏跳profile页
          yoda.register({
            namespace: 'component',
            name: 'closeLiveHalfWeb'
          }); // 关闭半屏h5 isLiving=true
          yoda.register({
            namespace: 'component',
            name: 'openLiveGiftPanel'
          }); // 直播间内 打开礼物面板
          yoda.register({
            namespace: 'component',
            name: 'login'
          });
          yoda.register({
            namespace: 'component',
            name: 'StopPullLoading'
          });
          yoda.register({
            namespace: 'component',
            name: 'share'
          });
          yoda.register({
            namespace: 'component',
            name: 'directShare'
          });
          yoda.register({
            namespace: 'component',
            name: 'hasInstalledApp'
          });
          yoda.register({
            namespace: 'component',
            name: 'bindPhone'
          });
          yoda.register({
            namespace: 'component',
            name: 'liveAccess'
          });
          yoda.register({
            namespace: 'component',
            name: 'selectCountryPhoneCode'
          });
          yoda.register({
            namespace: 'component',
            name: 'getCurrentCountryCode'
          });
          yoda.register({
            namespace: 'view',
            name: 'exitWebView'
          });
          yoda.register({
            namespace: 'ui',
            name: 'setPhysicalBackButtonBehavior'
          });
          yoda.register({
            namespace: 'tool',
            name: 'checkAppInstalled'
          });
          yoda.register({
            namespace: 'kwai',
            name: 'saveImage'
          });
          yoda.register({
            namespace: 'view',
            name: 'requestDisallowInterceptTouchEvent'
          });
          yoda.register({
            namespace: 'business',
            name: 'stopShowLoading'
          });
          yoda.register({
            namespace: 'business',
            name: 'isCopaShowing'
          });
          yoda.ready().then(function () {
            // 监听h5-closeAll-webview事件 当事件触发时关闭当前Webview
            yoda.event.addEventListener('h5-closeAll-webview', function () {
              var count = 0;
              var timer = setTimeout(function () {
                count++;
                if (count >= 10) {
                  clearTimeout(timer);
                }
                yoda.webview.close();
              });
            });
          });
        case 27:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}))();
export { yoda };
/**
 *
 * @param url 打开的链接
 * @param options webview 相关的配置
 * @param query 需要拼接在url上的参数
 */
export function openWebview(url) {
  var _yoda$webview;
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var queryArr = Object.entries(query).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return "".concat(key, "=").concat(value);
  });
  queryArr.unshift('webview=yoda');
  var queryStr = queryArr.join('&');
  var joiner = url.indexOf('?') !== -1 ? '&' : '?';
  url += joiner + queryStr;
  if (url.startsWith('/')) {
    url = "".concat(window.location.origin).concat(url);
  }
  if (!isYodaEnv) {
    window.location.href = url;
    return;
  }
  var defaultOptions = {
    titleColor: '#222222'
  };
  var launchOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
  (_yoda$webview = yoda.webview) === null || _yoda$webview === void 0 ? void 0 : _yoda$webview.open({
    url: url,
    launchOptions: launchOptions
  });
}
export function openWebviewWithoutYoda(url) {
  var _yoda$webview2;
  if (url.startsWith('/')) {
    url = "".concat(window.location.origin).concat(url);
  }
  var defaultOptions = {
    titleColor: '#222222'
  };
  var launchOptions = _objectSpread({}, defaultOptions);
  (_yoda$webview2 = yoda.webview) === null || _yoda$webview2 === void 0 ? void 0 : _yoda$webview2.open({
    url: url,
    launchOptions: launchOptions
  });
}
/**
 * 打开新的页面
 * 若URL中存在Webview=yoda参数 则使用Yoda容器打开 若不存在则使用Ks容器打开
 * @param url 链接地址
 */
export var openStaticPage = function openStaticPage(url) {
  if (url.includes('webview=yoda')) {
    return openWebview(url);
  }
  window.location.href = url;
};
export var setTitleColor = function setTitleColor(color) {
  yoda.ui.hideLoadingPage();
  yoda.ui.setTitle({
    color: color || '#222222'
  });
};
export var showToast = function showToast(text, type) {
  yoda.ui.showToast({
    text: text,
    type: type
  });
};
export var setFullScreen = function setFullScreen() {
  yoda.ui.setTopBarStyle({
    position: 'fixed'
  });
};
export var closeWebview = function closeWebview() {
  try {
    var _yoda$webview3;
    if (!isYodaEnv) {
      window.close();
      return;
    }
    yoda === null || yoda === void 0 ? void 0 : (_yoda$webview3 = yoda.webview) === null || _yoda$webview3 === void 0 ? void 0 : _yoda$webview3.close();
  } catch (error) {
    //
  }
};